<mat-form-field appearance="outline" class="w-full" subscriptSizing="dynamic">
  <input
    matInput
    rmsInputMask
    [mask]="mask"
    [formControl]="searchControl"
    type="text"
    [placeholder]="
      placeholder ?? 'libs.timezone-select.placeholder' | translate
    "
    [matAutocomplete]="auto"
  />
  <mat-autocomplete
    #auto="matAutocomplete"
    [hideSingleSelectionIndicator]="true"
  >
    @for (group of filteredGroupedTimezones; track group.continent) {
      <ng-container>
        <mat-optgroup [label]="group.continent">
          @for (tz of group.timezones; track tz) {
            <mat-option
              [class.mdc-list-item--selected]="searchControl.value === tz"
              [value]="tz"
              (click)="onSelectionChange(tz)"
            >
              {{ tz }}
            </mat-option>
          }
        </mat-optgroup>
      </ng-container>
    }
  </mat-autocomplete>
  @if (selectorHint) {
    <mat-hint>{{ selectorHint | translate }}</mat-hint>
  }
</mat-form-field>
